import { APP_INITIALIZER, Provider } from '@angular/core';
import {
    initializeKeycloak,
    LoginManager
} from '@flyfreely-portal-ui/flyfreely';

/**
 * Starts Keycloak before the app loads. The `e2e` build configurations replace this file with
 * `keycloak.providers.e2e.ts`, which signs in a test user without Keycloak.
 */
export const keycloakProviders: Provider[] = [
    {
        provide: APP_INITIALIZER,
        useFactory: initializeKeycloak,
        multi: true,
        deps: [LoginManager]
    }
];
